import { Allocation, Identifiable, Status, Task } from "@planzone/dto";

function getTaskAllocatedHours(allocations: Allocation[]): number {
  return allocations.reduce(
    (sum, { allocatedHours }) =>
      sum + (allocatedHours === 0 ? 1 : allocatedHours),
    0,
  );
}

function calculateFromAllocations(allocations: Allocation[]): number {
  const totalAllocatedHours = getTaskAllocatedHours(allocations);

  return totalAllocatedHours !== 0
    ? Math.floor(
        allocations.reduce(
          (sum, { percentComplete, allocatedHours }) =>
            sum +
            ((allocatedHours === 0 ? 1 : allocatedHours) /
              totalAllocatedHours) *
              (percentComplete / 100),
          0,
        ) * 100,
      )
    : 0;
}

function calculateFromStatus({ percentComplete }: Status): number {
  return percentComplete || 0;
}

function hasAllocations({ allocations }: Identifiable<Task>): boolean {
  return allocations.length > 0;
}

function isCompleted({ status }: Identifiable<Task>): boolean {
  return status.percentComplete === 100;
}

function calculateAllocationAdvancement(
  allocation: Identifiable<Allocation>,
  task: Identifiable<Task>,
): Identifiable<Allocation> {
  return {
    ...allocation,
    percentComplete: isCompleted(task) ? 100 : allocation.percentComplete,
  };
}

function calculateAdvancement(task: Identifiable<Task>): Identifiable<Task> {
  return {
    ...task,
    percentComplete: isCompleted(task)
      ? 100
      : hasAllocations(task)
        ? calculateFromAllocations(task.allocations)
        : calculateFromStatus(task.status),
    allocations: task.allocations.map((allocation) =>
      calculateAllocationAdvancement(allocation, task),
    ),
  };
}

export { calculateAdvancement };
